import React, { Component } from 'react';
import UserPageWrapper from '../../wrappers/UserPageWrapper';
import PageContent from './PageContent';

export default function UserDetailPage(props) {
  return <UserPageWrapper {...props} isUserDetailPage={true}>
    <PageContent />
  </UserPageWrapper>;
}
